import React from "react";
import { MenuItem, Select } from "@mui/material";
import { styled } from "@mui/material/styles";
import IcADSArrowDown from "./ADSArrowDown.svg";
import IcADSArrowDownDisabled from "./ADSArrowDownDisabled.svg";
import Skeleton from "@mui/material/Skeleton";
import IcTickFilled from "../../../../../../../../../../Assets/Icons/tick-filled.svg";

const CustomArrowDown = ({ disabled, ...restProps }) => (
  <img
    {...restProps}
    src={disabled ? IcADSArrowDownDisabled : IcADSArrowDown}
    alt="arrow-dropdown"
    style={{ cursor: "pointer" }}
  />
);

const CustomSelect = styled(Select)({
  backgroundColor: "#FFF1F2",
  borderRadius: "15px",
  "&.Mui-focused": {
    backgroundColor: "#FFF1F2",
  },
  "&:hover": {
    backgroundColor: "#FFF1F2",
  },
  "&::before, &::after": {
    display: "none",
  },
  "&.Mui-disabled": {
    backgroundColor: "#DEDEDE",
    "& .MuiSelect-select": {
      color: "#1D1B201A",
      WebkitTextFillColor: "#1D1B201A",
    },
  },
  "& .MuiSelect-select": {
    fontFamily: "Inter",
    fontWeight: 500,
    fontSize: "18px",
    color: "#171717",
    padding: "20px 0",
    paddingLeft: "32px",

    "&:focus": {
      backgroundColor: "transparent",
    },
  },
  "& .MuiSelect-icon": {
    top: "inherit",
  },
});

const ADSSelect = ({
  value,
  onChange,
  options,
  defaultValue,
  loading,
  disabled,
  isModelSelection = false,
}) => {
  const renderMenuItemNormal = () => {
    return options.map((option) => {
      const isActive = option.value === value;
      return (
        <MenuItem
          key={option.value}
          value={option.value}
          sx={{
            flexDirection: "column",
            alignItems: "flex-start",
            padding: "10px",
            margin: "4px",
            borderRadius: "10px",
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              flex: 1,
              width: "100%",
            }}
          >
            <div>
              <span style={{ fontWeight: 700, fontSize: 16 }}>
                {option.label}&nbsp;
              </span>
            </div>

            {isActive && <img src={IcTickFilled} alt="icon" />}
          </div>
        </MenuItem>
      );
    });
  };

  const renderMenuItemCustom = () => {
    return options.map((option) => {
      const isActive = option.value === value;
      return (
        <MenuItem
          key={option.value}
          value={option.value}
          sx={{
            flexDirection: "column",
            alignItems: "flex-start",
            padding: "10px",
            margin: "4px",
            borderRadius: "10px",
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              flex: 1,
              width: "100%",
            }}
          >
            <div>
              <div>
                <span style={{ fontWeight: 600, fontSize: 14 }}>
                  {option.shortLabel}&nbsp;
                </span>
                <span style={{ fontSize: 14 }}>{option.creditsLabel}</span>
              </div>

              {option.description && (
                <div
                  style={{ display: "flex", flexWrap: "wrap", fontSize: 10 }}
                >
                  {option.description}
                </div>
              )}
            </div>

            {isActive && <img src={IcTickFilled} alt="icon" />}
          </div>
        </MenuItem>
      );
    });
  };

  if (loading) {
    return (
      <Skeleton variant="rounded" height={60} sx={{ borderRadius: "15px" }} />
    );
  }

  return (
    <CustomSelect
      fullWidth
      defaultValue={defaultValue}
      value={value}
      // Somehow matterial UI adding padding to the header tag, so we need to disable scroll lock
      // Reference: https://stackoverflow.com/questions/60682426/material-ui-adds-padding-to-the-body-tag-when-a-dialog-is-opened
      inputProps={{
        MenuProps: {
          disableScrollLock: true,
          PaperProps: {
            sx: {
              borderRadius: "10px",
              backgroundColor: "#F8F9FA",
              maxWidth: 507,
              color: "#171717",

              "& .MuiList-root": {
                paddingTop: 0,
                paddingBottom: 0,
              },

              "& .MuiButtonBase-root.Mui-selected": {
                backgroundColor: "#FFF1F2",
                color: "#171717",
              },

              "& .MuiMenuItem-root.Mui-selected.Mui-focusVisible": {
                backgroundColor: "#FFF1F2",
                outline: "none",
                "&::after": {
                  display: "none",
                },
              },
            },
          },
        },
      }}
      onChange={(e) => onChange(e.target.value)}
      variant="filled"
      IconComponent={(props) => CustomArrowDown({ disabled, ...props })}
      disabled={disabled}
      renderValue={(selected) => {
        const selectedInfo = options.find(
          (option) => option.value === selected
        );
        return <span>{selectedInfo?.label}</span>;
      }}
    >
      {isModelSelection ? renderMenuItemCustom() : renderMenuItemNormal()}
    </CustomSelect>
  );
};

export default ADSSelect;
